import { Grid } from "@scuf/common";
import React from "react";
import KPIStat from "../../components/common/KPIStat/KPIStat";

const Indicadores = () => {
  return (
    <>
      <Grid.Row>
        <Grid.Column xsWidth="12" sWidth="6" mWidth="6" lWidth="6" xlWidth="6">
          <Grid.Row>
            <Grid.Column
              xsWidth="12"
              sWidth="3"
              mWidth="3"
              lWidth="3"
              xlWidth="3"
            >
              <div style={{ padding: "0px" }}>
                <KPIStat
                  url="sp_GetData"
                  body={{ params: "020101" }}
                  isCard="1"
                  titleCard="GLOBAL"
                />
              </div>
            </Grid.Column>
            <Grid.Column
              xsWidth="12"
              sWidth="3"
              mWidth="3"
              lWidth="3"
              xlWidth="3"
            >
              <div style={{ padding: "0px" }}>
                <KPIStat
                  url="sp_GetData"
                  body={{ params: "020102" }}
                  isCard="1"
                  titleCard="CHUQUICAMATA"
                />
              </div>
            </Grid.Column>
            <Grid.Column
              xsWidth="12"
              sWidth="3"
              mWidth="3"
              lWidth="3"
              xlWidth="3"
            >
              <div style={{ padding: "0px" }}>
                <KPIStat
                  url="sp_GetData"
                  body={{ params: "020107" }}
                  isCard="1"
                  titleCard="RADOMIRO TOMIC"
                />
              </div>
            </Grid.Column>
            <Grid.Column
              xsWidth="12"
              sWidth="3"
              mWidth="3"
              lWidth="3"
              xlWidth="3"
            >
              <div style={{ padding: "0px" }}>
                <KPIStat
                  url="sp_GetData"
                  body={{ params: "020103" }}
                  isCard="1"
                  titleCard="MINISTRO HALES"
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid.Column>
        <Grid.Column xsWidth="12" sWidth="6" mWidth="6" lWidth="6" xlWidth="6">
          <Grid.Row>
            <Grid.Column
              xsWidth="12"
              sWidth="3"
              mWidth="3"
              lWidth="3"
              xlWidth="3"
            >
              <div style={{ padding: "0px" }}>
                <KPIStat
                  url="sp_GetData"
                  body={{ params: "020108" }}
                  isCard="1"
                  titleCard="GABRIELA MISTRAL"
                />
              </div>
            </Grid.Column>
            <Grid.Column
              xsWidth="12"
              sWidth="3"
              mWidth="3"
              lWidth="3"
              xlWidth="3"
            >
              <div style={{ padding: "0px" }}>
                <KPIStat
                  url="sp_GetData"
                  body={{ params: "020104" }}
                  isCard="1"
                  titleCard="SALVADOR"
                />
              </div>
            </Grid.Column>

            <Grid.Column
              xsWidth="12"
              sWidth="3"
              mWidth="3"
              lWidth="3"
              xlWidth="3"
            >
              <div style={{ padding: "0px" }}>
                <KPIStat
                  url="sp_GetData"
                  body={{ params: "020105" }}
                  isCard="1"
                  titleCard="ANDINA"
                />
              </div>
            </Grid.Column>
            <Grid.Column
              xsWidth="12"
              sWidth="3"
              mWidth="3"
              lWidth="3"
              xlWidth="3"
            >
              <div style={{ padding: "0px" }}>
                <KPIStat
                  url="sp_GetData"
                  body={{ params: "020106" }}
                  isCard="1"
                  titleCard="EL TENIENTE"
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid.Column>
      </Grid.Row>
    </>
  );
};

export default Indicadores;
